<template>
  <div>
      <div class="container">  
      <b-navbar>
        <template #start>
            <b-navbar-item v-bind:href="apiUrl">
              <span class="content is-size-2 has-text-weight-bold">
                <font-awesome-icon icon="film" /> Rollideo
              </span>
            </b-navbar-item>
        </template>
        <template #end>
            <b-navbar-dropdown label="API">
                <b-navbar-item v-bind:href="apiUrl + '/apistep'">
                    <strong>API Quick Start</strong>
                </b-navbar-item>
                <b-navbar-item v-bind:href="apiUrl + '/apiguide'">
                    <strong>API documentation</strong>
                </b-navbar-item>
            </b-navbar-dropdown>

            <b-navbar-item href="https://rollideo.com/blog/mainpage">
                <strong>Blog</strong>
            </b-navbar-item>

             <b-navbar-item v-bind:href="apiUrl + '/contact'">
                <strong>Contact</strong>
            </b-navbar-item>

            <b-navbar-item v-bind:href="apiUrl + '/subscribe'">       
                <strong>Sign up</strong>
            </b-navbar-item>

            <b-navbar-item v-bind:href="apiUrl + '/login'">
                <strong>Log in</strong>
            </b-navbar-item>
        </template>
      </b-navbar> 
        <div class="box has-background-grey-lighter" >
          <h1 class="title is-3 has-text-info">Terms and Conditions of rollideo.com</h1>
          <div class="pre-formatted">

These Terms govern the use of this application, and any other related agreement or legal relationship with the owner in a legally binding way. 

Information about this application
Rollideo is a video generation platform

"This Application" refers to

this website, including its subdomains and any other website through which the Owner makes its Service available;
applications for mobile, tablet and other smart device systems;
the Application Program Interfaces (API);
the Service;
any applications, sample and content files, source code, scripts, instruction sets or software included as part of the Service, as well as any related documentation;

This Application is provided by:
Rollideo SIRET 81364075200016
Adresse : 250 rue des Eucalyptus 34090 Montpellier - France


TERMS OF USE
Unless otherwise specified, the terms of use detailed in this section apply generally when using this Application.

Single or additional conditions of use or access may apply in specific scenarios and in such cases are additionally indicated within this document.

By using this Application, Users confirm to meet the following requirements:

There are no restrictions for Users in terms of being Consumers or Business Users;
Account registration
To use the Service Users may register or create a User account, providing all required data or information in a complete and truthful manner.
Users may also use the Service without registering or creating a User account, however, this may cause limited availability of certain features or functions.

Users are responsible for keeping their login credentials confidential and safe. For this reason, Users are also required to choose passwords that meet the highest standards of strength permitted by this Application.

By registering, Users agree to be fully responsible for all activities that occur under their username and password.
Users are required to immediately and unambiguously inform the Owner if they think their personal information, including but not limited to User accounts, access credentials or personal data, have been violated, unduly disclosed or stolen.

Conditions for account registration
Registration of User accounts on this Application is subject to the conditions outlined below. By registering, Users agree to meet such conditions.

Accounts registered by bots or any other automated methods are not permitted.
Unless otherwise specified, each User must register only one account.
Unless explicitly permitted, a User account may not be shared with other persons.

Account termination
Users can terminate their account and stop using the Service at any time.

Account suspension and deletion
The Owner reserves the right to suspend or terminate the User's account at any time and without notice, at the Owner's sole discretion, in these cases:

User has violated these Terms; and/or

User's access or use of this Application may cause injury to the Owner, other Users or third parties; and/or

the use of this Application by the User may cause violation of law or regulations; and/or

in case of an investigation by legal action or governmental involvement; and/or

the account or its use is deemed to be, at the Owner’s sole discretion inappropriate or offensive or in violation of these Terms.

The suspension or deletion of User accounts shall not entitle Users to any claims for compensation, damages or reimbursement.
The suspension or deletion of accounts due to causes attributable to the User does not exempt the User from paying any applicable fees or prices.

Content on this Application
Unless where otherwise specified or clearly recognizable, all content available on this Application is owned or provided by the Owner or its licensors.

The Owner undertakes its utmost effort to ensure that the content provided on this Application infringes no applicable legal provisions or third-party rights. 

Rights regarding content on this Application - All rights reserved
The Owner holds and reserves all intellectual property rights for any such content.

Users may not therefore use such content in any way that is not necessary or implicit in the proper use of the Service.



Content provided by Users
The Owner allows Users to upload, share or provide their own content to this Application.

By providing content to this Application, Users confirm that they are legally allowed to do so and that they are not infringing any statutory provisions and/or third-party rights.

Rights regarding content provided by Users
Users acknowledge and accept that by providing their own content on this Application they grant the Owner a non-exclusive, fully paid-up and royalty-free license to process such content.

Users acknowledge, accept and confirm that all content they provide through this Application is provided subject to the same general conditions set forth for content on this Application.

Liability for provided content
Users are solely liable for any content they upload, post, share, or provide through this Application. Users acknowledge and accept that the Owner does not filter or moderate such content.

However, the Owner reserves the right to remove, delete, block or rectify such content at its own discretion and to, without prior notice, deny the uploading User access to this Application:

if any complaint based on such content is received;
if a notice of infringement of intellectual property rights is received;
upon order of a public authority; or
where the Owner is made aware that the content, while being accessible via this Application, may represent a risk for Users, third parties and/or the availability of the Service.
The removal, deletion, blocking or rectification of content shall not entitle Users that have provided such content or that are liable for it, to any claims for compensation, damages or reimbursement.
Users agree to hold the Owner harmless from and against any claim asserted and/or damage suffered due to content they provided to or provided through this Application.

Access to provided content
Content that Users provide to this Application is made available according to the criteria outlined within this section.

Publicly available content
Content meant for public availability shall be automatically made public on this Application upon upload or, at the sole discretion of the Owner, at a later stage.

No personal data, identifier or any other information related to Users (such as a User-ID, avatar or nickname etc.) shall appear in connection with the published content, unless Users decide otherwise on their own initiative.

Private content
Private content provided by Users shall stay private and will not be shared with any third parties or accessed by the Owner without the User’s explicit consent.

Access to external resources
Through this Application Users may have access to external resources provided by third parties. Users acknowledge and accept that the Owner has no control over such resources and is therefore not responsible for their content and availability.

Conditions applicable to any resources provided by third parties, including those applicable to any possible grant of rights in content, result from each such third parties’ terms and conditions or, in the absence of those, applicable statutory law.



Acceptable use
This Application and the Service may only be used within the scope of what they are provided for, under these Terms and applicable law.

Users are solely responsible for making sure that their use of this Application and/or the Service violates no applicable law, regulations or third-party rights.

Therefore, the Owner reserves the right to take any appropriate measure to protect its legitimate interests including denying Users access to this Application or the Service, terminating contracts, reporting any misconduct performed through this Application or the Service to the competent authorities – such as judicial or administrative authorities - whenever Users are suspected to be in violation of any laws, regulations, third-party rights and/or these Terms, including, but not limited to, by engaging in any of the following activities:

Conduct restrictions
pretending to fulfill any possible condition or requirements for accessing this Application and/or using the Services, such as for instance being adult according to law or qualifying as a Consumer;
concealing their identity or stealing someone else's identity or pretend to be or represent a third-party, if not allowed to do so by such third-party;
manipulating identifiers to disguise or otherwise conceal the origin of their messages or of the content posted;
defaming, abusing, harassing, using threatening practices, threatening or violating the legal rights of others in any other way;
promoting activity that may endanger the User’s life or the life of any other User or lead to physical harm. This includes but is not limited to suicide threats or instigations, intentional physical trauma, the use of illegal drugs, or excessive drinking. Under no circumstance is any User allowed to post any content promoting and/or encouraging and/or showing any self-destructive or violent behavior on this Application;
probing, scanning or testing the vulnerability of this Application, including the services or any network connected to the website, nor breaching the security or authentication measures on this Application, including the services or any network connected to this Application;
installing, embedding, uploading or otherwise incorporating any malware into or via this Application;
using this Application or the technical infrastructure in an abusive, excessive or otherwise inappropriate way (for example: for spamming purposes);
attempting to disrupt or tamper with the technical infrastructure in a manner that harms or places an undue burden on this Application or the Service;

Content restrictions
disseminating or publishing content that is unlawful, obscene, illegitimate, libelous or inappropriate;
publishing any content that promotes, either directly or indirectly, hate, racism, discrimination, pornography, violence;
disseminating or publishing any content that is false or may create unjustified alarm;
using this Application to publish, disseminate or otherwise provide content protected by intellectual property laws, including but not limited to patent, trademark or copyright law, unlawfully and without the legitimate right-holder’s consent;
using this Application to publish, disseminate or otherwise make available any other content which infringes on any third-party rights, including but not limited to state, military, trade or professional secrets and personal data;
publishing any content or carrying out any activity that disrupts, interrupts, harms, or otherwise violates the integrity of this Application or another User's experience or devices. Such activities include: spamming, distributing unauthorized advertisements, phishing, defrauding others, spreading malware or viruses etc.;

User protection
misappropriating any account in use by another User;
harvesting or collecting any personally identifying information of other Users including but not limited to their email addresses or contact information, by circumventing the privacy setting of other Users’ accounts on this Application or by any other means;
using any information relating to other Users, including personal or contact data, for purposes other than those this Application is intended for;
Software license
Any intellectual or industrial property rights, and any other exclusive rights on software or technical applications embedded in or related to this Application are held by the Owner and/or its licensors.

Subject to Users’ compliance with and notwithstanding any divergent provision of these Terms, the Owner merely grants Users a revocable, non-exclusive, non-sublicensable and non-transferable license to use the software and/or any other technical means embedded in the Service within the scope and for the purposes of this Application and the Service offered.

This license does not grant Users any rights to access, usage or disclosure of the original source code. All techniques, algorithms, and procedures contained in the software and any documentation thereto related is the Owner’s or its licensors’ sole property.

All rights and license grants to Users shall immediately terminate upon any termination or expiration of the Agreement.

Common provisions

No Waiver
The Owner’s failure to assert any right or provision under these Terms shall not constitute a waiver of any such right or provision. No waiver shall be considered a further or continuing waiver of such term or any other term.

Service interruption
To ensure the best possible service level, the Owner reserves the right to interrupt the Service for maintenance, system updates or any other changes, informing the Users appropriately.

Within the limits of law, the Owner may also decide to suspend or terminate the Service altogether. If the Service is terminated, the Owner will cooperate with Users to enable them to withdraw Personal Data or information in accordance with applicable law.

Additionally, the Service might not be available due to reasons outside the Owner’s reasonable control, such as “force majeure” (eg. labor actions, infrastructural breakdowns or blackouts etc).

Service reselling
Users may not reproduce, duplicate, copy, sell, resell or exploit any portion of this Application and of its Service without the Owner’s express prior written permission, granted either directly or through a legitimate reselling programme.

Intellectual property rights
Without prejudice to any more specific provision of these Terms, any intellectual property rights, such as copyrights, trademark rights, patent rights and design rights related to this Application are the exclusive property of the Owner or its licensors and are subject to the protection granted by applicable laws or international treaties relating to intellectual property.

All trademarks — nominal or figurative — and all other marks, trade names, service marks, word marks, illustrations, images, or logos appearing in connection with this Application are, and remain, the exclusive property of the Owner or its licensors and are subject to the protection granted by applicable laws or international treaties related to intellectual property.

Changes to these Terms
The Owner reserves the right to amend or otherwise modify these Terms at any time. In such cases, the Owner will appropriately inform the User of these changes.

Such changes will only affect the relationship with the User for the future.

The continued use of the Service will signify the User’s acceptance of the revised Terms. If Users do not wish to be bound by the changes, they must stop using the Service. Failure to accept the revised Terms, may entitle either party to terminate the Agreement.


Assignment of contract
The Owner reserves the right to transfer, assign, dispose of by novation, or subcontract any or all rights or obligations under these Terms, taking the User’s legitimate interests into account. Provisions regarding changes of these Terms will apply accordingly.

Users may not assign or transfer their rights or obligations under these Terms in any way, without the written permission of the Owner.

Governing law
These Terms are governed by the law of the place where the Owner is based, without regard to conflict of laws principles.

Venue of jurisdiction
The exclusive competence to decide on any controversy resulting from or connected to these Terms lies with the courts of the place where the Owner is based.

Dispute resolution
Amicable dispute resolution
Users may bring any disputes to the Owner who will try to resolve them amicably.

While Users' right to take legal action shall always remain unaffected, in the event of any controversy regarding the use of this Application or the Service, Users are kindly asked to contact the Owner.

The User may submit the complaint including a brief description and if applicable, the details of the related order, purchase, or account, to the Owner.

Online dispute resolution for Consumers
The European Commission has established an online platform for alternative dispute resolutions that facilitates an out-of-court method for solving any dispute related to and stemming from online sale and service contracts.

As a result, any European Consumer can use such platform for resolving any dispute stemming from contracts which have been entered into online. 

Latest update: July 22, 2021
        </div>
      </div>
    </div>

    <footer class="footer">
        <nav class="level">

          <div class="level-item has-text-centered">
              <a v-bind:href="apiUrl + '/about'">About Rollideo</a> 
          </div>

          <div class="level-item has-text-centered">
              <a v-bind:href="apiUrl + '/contact'">Contact</a> 
          </div>
        </nav>  
    </footer>

  </div>    
</template>

<script>
import axios from 'axios'
export default {
    data () {
            return {
              apiUrl : ''
            }
    }, 
    created () {
      this.apiUrl = process.env.API_URL;
    } 
  }
</script>

<style scoped>
.pre-formatted {
  white-space: pre-wrap;
}
 </style>



// WEBPACK FOOTER //
// src/components/Terms.vue